"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsPanel = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _WebNotification = require("./WebNotification");

var _molecules = require("../../molecules");

var _helpers = require("../../util/helpers");

var _Modal = require("../../molecules/Modal");

var _DropdownMenu = require("../../molecules/DropdownMenu");

var _atoms = require("../../atoms");

var _NotificationsEmptyState = require("./NotificationsEmptyState");

var _NotificationAnonymous = require("./NotificationAnonymous");

require("./NotificationsPanel.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var NotificationsPanel = function NotificationsPanel(_ref) {
  var notifications = _ref.notifications,
      onBackClick = _ref.onBackClick,
      _onNotificationClick = _ref.onNotificationClick,
      _onActionClick = _ref.onActionClick,
      welcomeMessage = _ref.welcomeMessage,
      availableTeams = _ref.availableTeams,
      selectedTeam = _ref.selectedTeam,
      setSelectedTeam = _ref.setSelectedTeam,
      showFilters = _ref.showFilters,
      setViewed = _ref.setViewed,
      showAnonymousNotification = _ref.showAnonymousNotification,
      onSignIn = _ref.onSignIn;
  var lastGroup = "";

  var getTimeSort = function getTimeSort(messageDate) {
    var difference = (0, _moment.default)().diff(messageDate, 'days', true);
    var group = difference < 1 ? 'Today' : difference > 7 ? "Last 30 days" : "Yesterday";

    if (group !== lastGroup) {
      lastGroup = group;
      return /*#__PURE__*/_react.default.createElement(_atoms.Label, {
        content: group,
        color: _atoms.Color.Grey2,
        type: _atoms.Label.Type.Heading5,
        bold: true,
        paddingLeft: "13",
        paddingTop: "8",
        paddingBottom: "2",
        className: "group-label"
      });
    }
  };

  var onChange = function onChange(e, value) {
    if (typeof setSelectedTeam === "function") {
      setSelectedTeam(value);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "NotificationsPanel"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "title",
    center: true
  }, /*#__PURE__*/_react.default.createElement(_Modal.CloseButton, {
    onClick: onBackClick
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading4,
    color: _atoms.Color.Black,
    content: "Updates",
    marginTop: "4",
    marginBottom: "4"
  })), showFilters && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "FilterMenu"
  }, /*#__PURE__*/_react.default.createElement(_DropdownMenu.DropdownMenu, {
    title: "Notifications",
    menuPortal: "#modal-root",
    options: availableTeams,
    className: "NotificationsDropdown",
    onChange: onChange,
    menuDirection: "right",
    offsetAxisX: (0, _helpers.isSmallScreen)() ? -740 : -130,
    offsetAxisY: 180,
    button: /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
      content: selectedTeam,
      icon: _atoms.Icon.Type.CheveronDown,
      background: selectedTeam !== "all" ? _atoms.Color.Black : _atoms.Color.Grey4,
      color: selectedTeam !== "all" ? _atoms.Color.White2 : _atoms.Color.Black,
      icon_on_right: true,
      fat: true,
      className: "Chip notifications-filter-chip",
      margin: "4"
    })
  })), (notifications === null || notifications === void 0 ? void 0 : notifications.length) === 0 && !showAnonymousNotification && /*#__PURE__*/_react.default.createElement(_NotificationsEmptyState.NotificationsEmptyState, {
    welcomeMessage: welcomeMessage
  }), showAnonymousNotification && /*#__PURE__*/_react.default.createElement(_NotificationAnonymous.NotificationsAnonymous, {
    onSignIn: onSignIn
  }), (notifications === null || notifications === void 0 ? void 0 : notifications.length) > 0 && !showAnonymousNotification && /*#__PURE__*/_react.default.createElement(_atoms.Column, null, notifications.map(function (notification) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getTimeSort(notification.msg_date), /*#__PURE__*/_react.default.createElement(_WebNotification.WebNotification, {
      key: "web-notification-".concat(notification.msg_id),
      notification: notification,
      onNotificationClick: function onNotificationClick(e) {
        return _onNotificationClick(e, notification);
      },
      onActionClick: function onActionClick(e, action, notification) {
        return _onActionClick(e, action, notification);
      },
      setViewed: setViewed
    }));
  })));
};

exports.NotificationsPanel = NotificationsPanel;